import React from "react";
import {
    Navigate,
} from "react-router-dom";

const ResourcesStatisticsListComponent = React.lazy(() => import("../../../../../components/statistics/page"));


export const resourcesStatisticsRoute = [
    {
        path: 'list',
        element: <ResourcesStatisticsListComponent />,
    },
    {
        path: '',
        element: <Navigate replace to="/resources/statistics/list" />
    },
];